import { ServerResponse } from './ServerResponse';
import { EntityType } from "../models/EntityType";
import { IdName } from "../models/IdName";
import { Header } from '../app/components/Header/Header';

// This is a method which makes actual HTTP request
// aciton – is an url to request
// data - data for post request's body
export function request<T>(action: string, data: any = null): Promise<T>
{
    if(action == null || action === "")
        throw '"action" is empty';

    let dataStr = (data != null) ? JSON.stringify(data) : undefined;
    let headers = new Headers();
    const selectedDivisionId = localStorage.getItem('selectedDivisionId');
    headers.append('Content-Type', 'application/json');
    headers.append('X-DivisionId', selectedDivisionId);

    return fetch(action, {
        method: dataStr != null ? 'POST' : 'GET',
        credentials: 'same-origin', //To automatically send cookies 
        body: dataStr,
        headers: headers
    }).then<T>(resp => {
        if(resp.ok)
            return resp.json();
        throw new Error(`status: ${resp.status} statusText: ${resp.statusText}`);
    })
}

//TResult | PromiseLike<TResult>
export function handleRedirect<T>(resp: ServerResponse<T>): T | PromiseLike<T>
{
    // Response could have redirect field. In this case we have to redirect user to specified url
    // This is mostly used to redirect user to login page when session is expired
    if(resp.redirect) {
        window.location.replace(resp.redirect);
        return new Promise<T>((resolve, reject) => {/* We are not going to resolve this promise */});
    } else {
        return resp.result;
    }
}

export function runAction<T>(action: string, data: any = null): Promise<T>
{
    return request<ServerResponse<T>>(action, data).then<T>(handleRedirect);
}


// WEBPACK FOOTER //
// ./src/rest/client.ts